import React from 'react';
import PropTypes from 'prop-types';
import { FormToggle } from '@ami/react/core';
import { formatDateWithTime } from '@ami/react/core';
import { makeConcealable } from '@ami/react/core';

class ProductThumbSelectionWarnings extends React.PureComponent {
  static propTypes = {
    entity: PropTypes.object.isRequired,
    noBuckets: PropTypes.bool.isRequired,
    noHaveSpecificationForBucket: PropTypes.bool.isRequired,
    onAgreeTerms: PropTypes.func,
    agreeTerms: PropTypes.bool,
    isAmiPriceLookupMode: PropTypes.bool.isRequired
  };

  render() {
    const {
      noBuckets,
      onAgreeTerms,
      agreeTerms,
      noHaveSpecificationForBucket,
      entity,
      isAmiPriceLookupMode,
    } = this.props;

    return (
      <div className="row justify-content-center text-center">
        <div className="banner-container">
          {noBuckets && (
            <div className={`alert alert-warning justify-content-center`}>
              No buckets were found on this quote. <br />
              Please make sure that any buckets are added to the quote before
              configuring a thumb.
            </div>
          )}
          {noHaveSpecificationForBucket &&  !isAmiPriceLookupMode && (
            <div className={`alert alert-warning justify-content-center`}>
              Lead times and availability of the thumb cannot be confirmed until
              the bucket specifications are provided.
              <br />
              It will not be possible submit a PO for this quote until this
              information is provided.
              <br />
              <br />
              {!entity.existingBucketSpecsNotAvailableAcknowledgedByUserId && (
                <FormToggle
                  label="I agree to the above terms "
                  checked={agreeTerms}
                  onChange={(agreeTerms) => {
                    onAgreeTerms(agreeTerms);
                  }}
                />
              )}
              {entity.existingBucketSpecsNotAvailableAcknowledgedByUserId && (
                <div>
                  Agreed to by{' '}
                  {entity.existingBucketSpecsNotAvailableAcknowledgedByUserName}{' '}
                  on{' '}
                  {formatDateWithTime(
                    entity.existingBucketSpecsNotAvailableAcknowledgedDate
                  )}
                </div>
              )}
            </div>
          )}
          {noHaveSpecificationForBucket &&  isAmiPriceLookupMode && (
            <div className={`alert alert-warning justify-content-center`}>
              Lead times and availability of the thumb cannot be confirmed until
              the bucket specifications are provided.
              <br />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default makeConcealable(ProductThumbSelectionWarnings);
